(function () {
    'use strict';

    angular
        .module('app.shared')
        .filter('enum', enumFilter);

    var isString = angular.isString,
        DEFAULT_PROP = 'displayName';

    enumFilter.$inject = ['$injector', 'gettextCatalog'];
    function enumFilter($injector, gettextCatalog) {
        function enumFilter(value, type, prop) {
            prop = prop || DEFAULT_PROP;
            return !isString(type) ? value : format(value);
            
            function format(value) {
                var $enum = $injector.has(type) && $injector.get(type),
                    meta = $enum && $enum.$metadata && $enum.$metadata[value];

                return gettextCatalog.getString(meta && meta[prop] || value);
            }
        }
        enumFilter.$stateful = true;
        return enumFilter;
    }
})();